import { render, staticRenderFns } from "./McpAuthorize.vue?vue&type=template&id=9befecfa&scoped=true&"
import script from "./McpAuthorize.vue?vue&type=script&lang=js&"
export * from "./McpAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./McpAuthorize.vue?vue&type=style&index=0&id=9befecfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9befecfa",
  null
  
)

export default component.exports